export enum TipoTransacaoContabil {
    Debito = 1,
    Credito = 2,
    Ajuste = 3
}

export const descricaoTipoTransacaoContabil: { [key: string]: string } = {
    [TipoTransacaoContabil.Debito]: "D",
    [TipoTransacaoContabil.Credito]: "C",
    [TipoTransacaoContabil.Ajuste]: "Ajuste"
};

export const selectIdentificacaoCpfCnpj: any[] = [
    { tipo: TipoTransacaoContabil.Debito, nome: descricaoTipoTransacaoContabil[TipoTransacaoContabil.Debito] },
    { tipo: TipoTransacaoContabil.Credito, nome: descricaoTipoTransacaoContabil[TipoTransacaoContabil.Credito] },
    { tipo: TipoTransacaoContabil.Ajuste, nome: descricaoTipoTransacaoContabil[TipoTransacaoContabil.Ajuste] }
];
